import {
  ExcursionAddOn,
  JourneyDayTripExcursionAddOnItem,
  JourneyDayTripExcursionItem,
} from "../../models/axiosModel"

/** Catalog from journey-details GET `excursion_add_ons` (prefer over options API). */
export const resolveExcursionAddOnCatalog = (
  excursion: Pick<JourneyDayTripExcursionItem, "excursion_add_ons"> | null | undefined,
): ExcursionAddOn[] =>
  Array.isArray(excursion?.excursion_add_ons) ? excursion!.excursion_add_ons! : []

/** Catalog items not already in selected `add_ons`. */
export const getAvailableExcursionAddOns = (
  catalog: ExcursionAddOn[] | undefined,
  selectedAddOns: JourneyDayTripExcursionAddOnItem[] | undefined,
): ExcursionAddOn[] => {
  const used = new Set(
    (selectedAddOns || [])
      .map((a) => String(a.excursion_add_on_id || "").trim())
      .filter(Boolean),
  )
  return (catalog || []).filter((a) => {
    const id = String(a.excursion_add_on_id || "").trim()
    return Boolean(id) && !used.has(id)
  })
}

/** True when catalog has at least one add-on (show + Add-on affordance). */
export const excursionSupportsAddOns = (
  excursion: Pick<JourneyDayTripExcursionItem, "excursion_add_ons"> | null | undefined,
): boolean => resolveExcursionAddOnCatalog(excursion).length > 0
